module.exports = __webpack_public_path__ + "img/cnu_gallery3.917c7a3f.jpg";